const state = () => ({
    inboxCounter: [],
})

const getters = {}

const actions = {
    getInboxCounter({state, commit}, this_) {
        this_.$http.get(process.env.VUE_APP_API_URL +'home/inboxcount').then(result => {
            commit("setInboxCounter", result.data);
        });
    },

}

const mutations = {
    setInboxCounter(state, count) {
        state.inboxCounter = count;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }